import { $_app_server } from '@/_helpers'

export const searchService = {
  search,
  getChunk,
  getana
}

function search(filter) {
  return $_app_server.post("public/search",filter)
    .then(response => {
        return response.data
    })
}

function getChunk(c,m) {
  return $_app_server.post("public/getchunk", {chunk:c,mode:m})
    .then(response => {
        return response.data
    })
}

function getana(cw) {
  return $_app_server.post("public/getana", cw)
    .then(response => {
        return response.data
    })
}